var map = {
	"./am.svg": 77909,
	"./am_blue_flash.svg": 15287,
	"./am_dark.svg": 13268,
	"./am_dark_no_background.svg": 99157,
	"./api.svg": 84489,
	"./api_blue_flash.svg": 84651,
	"./api_dark.svg": 39536,
	"./api_dark_no_background.svg": 46041,
	"./app.svg": 75632,
	"./app_blue_flash.svg": 35148,
	"./app_dark.svg": 63559,
	"./app_dark_no_background.svg": 58530,
	"./apps.svg": 56947,
	"./apps_blue_flash.svg": 92149,
	"./apps_dark.svg": 39850,
	"./apps_dark_no_background.svg": 26439,
	"./cc.svg": 33021,
	"./cc_blue_flash.svg": 5983,
	"./cc_dark.svg": 73228,
	"./cc_dark_no_background.svg": 16733,
	"./connectors.svg": 68527,
	"./connectors_blue_flash.svg": 66625,
	"./connectors_dark.svg": 74814,
	"./connectors_dark_no_background.svg": 88755,
	"./connectors_grey.svg": 22371,
	"./dm.svg": 50082,
	"./dm_blue_flash.svg": 90134,
	"./dm_dark.svg": 74665,
	"./dm_dark_no_background.svg": 43544,
	"./dpe.svg": 49560,
	"./dpe_blue_flash.svg": 56884,
	"./dpe_dark.svg": 3295,
	"./dpe_dark_no_background.svg": 30890,
	"./dwh.svg": 96224,
	"./dwh_dark.svg": 78903,
	"./gab.svg": 74011,
	"./gab_blue_flash.svg": 71965,
	"./gab_dark.svg": 63650,
	"./gab_dark_no_background.svg": 10831,
	"./gab_grey.svg": 61151,
	"./iam.svg": 65230,
	"./iam_blue_flash.svg": 850,
	"./iam_dark.svg": 44797,
	"./iam_dark_no_background.svg": 90356,
	"./infra.svg": 80395,
	"./infra_blue_flash.svg": 26125,
	"./infra_dark.svg": 98482,
	"./lakehouse.svg": 30518,
	"./lakehouse_blue_flash.svg": 98906,
	"./lakehouse_dark.svg": 29781,
	"./lakehouse_dark_no_background.svg": 66716,
	"./ml.svg": 42536,
	"./ml_blue_flash.svg": 71972,
	"./ml_dark.svg": 23279,
	"./ml_dark_no_background.svg": 4474,
	"./mlm.svg": 20141,
	"./mlm_blue_flash.svg": 93071,
	"./mlm_dark.svg": 55356,
	"./mlm_dark_no_background.svg": 15437,
	"./qb.svg": 79074,
	"./qb_blue_flash.svg": 81078,
	"./qb_dark.svg": 59017,
	"./qb_dark_no_background.svg": 29112,
	"./superset.svg": 13336,
	"./superset_blue_flash.svg": 85908,
	"./superset_dark.svg": 75679,
	"./superset_dark_no_background.svg": 41514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10761;